import { useState, useCallback } from "react"
import { MAX_VISIBLE_EVENTS } from "../constants"

const useGridVisibility = (maxVisible = MAX_VISIBLE_EVENTS) => {
  const [visibleCounts, setVisibleCounts] = useState({})

  const getVisibleCount = useCallback((key) => visibleCounts[key] ?? maxVisible, [visibleCounts, maxVisible])
  const showMore = useCallback((key) => setVisibleCounts((prev) => ({ ...prev, [key]: (prev[key] ?? maxVisible) + maxVisible })), [maxVisible])
  const showLess = useCallback((key) => setVisibleCounts((prev) => ({ ...prev, [key]: maxVisible })), [maxVisible])

  return { getVisibleCount, showMore, showLess, maxVisible }
}

export default useGridVisibility
